module.exports = __webpack_public_path__ + "static/media/temperature.f46811be.svg";